<app-dialog [dialogWithInput]="dialog">
    <app-card>
        <div class="row">
            <app-form-field [required]="true" label="Quantité" sizeLg="2" sizeXl="1">
                <app-number-input [parentFormGroup]="formGroup" parentFormControlName="quantity"></app-number-input>
            </app-form-field>
            <app-form-field [required]="true" label="% TVA" sizeLg="2" sizeXl="1">
                <app-number-input [maxValue]="100" [parentFormGroup]="formGroup" parentFormControlName="taxPercentage"
                                  [decimalDigits]="2" unit="%"></app-number-input>
            </app-form-field>
            <app-form-field [required]="true" label="PU HTVA" sizeLg="2" sizeXl="2">
                <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="unitPriceVatExcluded"
                                  unit="€ HTVA"></app-amount-input>
            </app-form-field>
            <app-form-field [required]="true" label="PU TTC" sizeLg="2" sizeXl="2">
                <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="unitPriceVatIncluded"
                                  unit="€ TTC"></app-amount-input>
            </app-form-field>
            <app-form-field [required]="true" label="Total" sizeLg="2" sizeXl="1">
                <app-price-label [price]="formGroup.get('totalPriceVatIncluded').value" currency="€"></app-price-label>
            </app-form-field>
        </div>
    </app-card>
    <app-button dialog-actions label="Modifier" fill="solid" (clickEvent)="update()" [loading]="saleUpdateSaleProductActionService.loading$ | async"></app-button>
</app-dialog>
